import type { DietPreference } from '@/types';

// Shared diet-preference labels. Single source of truth so the Settings
// "About you" card and the first-visit Nutrition setup modal stay in
// sync. Order matters — it's the order shown in the UI chip row.
export const DIET_OPTIONS: Array<{ v: DietPreference; en: string; de: string }> = [
  { v: 'omnivore',    en: 'Omnivore',    de: 'Allesesserin' },
  { v: 'vegetarian',  en: 'Vegetarian',  de: 'Vegetarisch' },
  { v: 'vegan',       en: 'Vegan',       de: 'Vegan' },
  { v: 'pescatarian', en: 'Pescatarian', de: 'Pescetarisch' },
  { v: 'halal',       en: 'Halal',       de: 'Halal' },
  { v: 'kosher',      en: 'Kosher',      de: 'Koscher' },
  { v: 'dairy_free',  en: 'Dairy-free',  de: 'Laktosefrei' },
  { v: 'gluten_free', en: 'Gluten-free', de: 'Glutenfrei' },
  { v: 'nut_free',    en: 'Nut-free',    de: 'Nussfrei' },
];
